export function removeEmptyEntries(
  object: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(Object.entries(object).filter(([_, v]) => v != ""));
}
